import Logger from "logger/logger"
import React, {lazy, LazyExoticComponent, Suspense, useEffect, useState} from "react"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"
import {ucFirst} from "utils/stringFunctions"

function ToolbarModuleController() {

  const {activeSystemModule} = SystemModuleService([
    subscribeSystemModule.activeSystemModule
  ], 'ToolbarModuleController')

  const [ModuleButtons, setModuleButtons] = useState<LazyExoticComponent<any>>(lazy(() => import('../../../emptyComponent')))

  useEffect(() => {
    Logger('Controller.Toolbar.Module.init')
    return () => {
      Logger('Controller.Toolbar.Module.unloading')
    }
  }, [])

  useEffect(function loadToolbarButtons() {
    if (undefined === activeSystemModule) return

    setModuleButtons(lazy(() => import(`./Module/${ucFirst(activeSystemModule.name)}/Toolbar`)))
  }, [activeSystemModule])

  return undefined === activeSystemModule ? null : (
    <Suspense fallback={<></>}>
      <ModuleButtons/>
    </Suspense>
  )
}

export default ToolbarModuleController
